// Polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from "vue";
import App from "./App.vue";
import Ionic from "@ionic/vue";
import "@ionic/core/css/core.css";
import "@ionic/core/css/ionic.bundle.css";
import { IonicVueRouter } from "@ionic/vue";
import LOGIN from "./components/log-in/log-in.vue";
import MAINPAGE from "./components/main-page/main-page.vue";
import MAKEAPPOINTMENTS from "./components/make-appointments/make-appointments.vue";
import CANCELAPPOINTMENTS from "./components/cancel-appointments/cancel-appointments.vue";
import VIEWEXISTINGAPPOINTMENTS from "./components/view-existing-appointments/view-existing-appointments.vue";
import CHANGEPASSWORD from "./components/change-password/change-password.vue";
import ADDPATIENTSSCREENONE from "./components/add-patients/add-patients-screen-one.vue";
import ADDPATIENTSSCREENTWO from "./components/add-patients/add-patients-screen-two.vue";
import OTHERPATIENTSSCREENONE from "./components/other-patients/other-patients-screen-one.vue";
import OTHERPATIENTSSCREENTWO from "./components/other-patients/other-patients-screen-two.vue";
import OTHERCANCELAPPOINTMENTS from "./components/other-patients/other-cancel-appointments.vue";
import OTHERMAKEAPPOINTMENTS from "./components/other-patients/other-make-appointments.vue";
import OTHERVIEWEXISTINGAPPOINTMENTS from "./components/other-patients/other-view-existing-appointments.vue";
import CHANGEUSER from "./components/change-user/change-user.vue";
import FORGOTPASSWORD from "./components/forgot-password/forgot-password.vue";
import RESETPASSWORD from "./components/reset-password/reset-password.vue";


import store from './store';

Vue.use(IonicVueRouter);

Vue.use(Ionic);
Vue.config.productionTip = false;

var router = new IonicVueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: LOGIN
    },
    {
      path: "/main",
      name: "main",
      component: MAINPAGE
    },
    {
      path: "/makeappointments",
      name: "makeappointments",
      component: MAKEAPPOINTMENTS
    },
    {
      path: "/cancelappointments",
      name: "cancelappointments",
      component: CANCELAPPOINTMENTS
    },
    {
      path: "/viewexistingappointments",
      name: "viewexistingappointments",
      component: VIEWEXISTINGAPPOINTMENTS
    },        
    {
      path: "/changepassword",
      name: "changepassword",
      component: CHANGEPASSWORD
    },            
    {
      path: "/addpatientsscreenone",
      name: "addpatientsscreenone",
      component: ADDPATIENTSSCREENONE
    },            
    {
      path: "/addpatientsscreentwo",
      name: "addpatientsscreentwo",
      component: ADDPATIENTSSCREENTWO
    },            
    {
      path: "/otherpatientsscreenone",
      name: "otherpatientsscreenone",
      component: OTHERPATIENTSSCREENONE
    },            
    {
      path: "/otherpatientsscreentwo",
      name: "otherpatientsscreentwo",
      component: OTHERPATIENTSSCREENTWO
    },            

    {
      path: "/othercancelappointments",
      name: "othercancelappointments",
      component: OTHERCANCELAPPOINTMENTS
    },            
    {
      path: "/othermakeappointments",
      name: "othermakeappointments",
      component: OTHERMAKEAPPOINTMENTS
    },            
    {
      path: "/otherviewexistingappointments",
      name: "otherviewexistingappointments",
      component: OTHERVIEWEXISTINGAPPOINTMENTS
    },            
    {
      path: "/changeUser",
      name: "changeuser",
      component: CHANGEUSER
    },            
    {
      path: "/forgotpassword",
      name: "forgotpassword",
      component: FORGOTPASSWORD
    },            
    {
      path: "/resetpassword",
      name: "resetpassword",
      component: RESETPASSWORD
    },            
  ]
});

new Vue({
  router,
  store,
  render: function (h) {
    return h(App);
  }
}).$mount('#app');